import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  children?: ReactNode;
}

export default function SectionTitle({
  title,
  subtitle,
  moreTo,
  moreLabel = '查看更多',
  icon,
  children,
}: SectionTitleProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950">
          {icon && (
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className={`${icon} text-base`}></i>
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3">
        {children}
        {moreTo && (
          <Link
            to={moreTo}
            className="flex items-center gap-1 text-sm text-foreground-500 transition-colors hover:text-accent-600 cursor-pointer whitespace-nowrap"
          >
            {moreLabel}
            <i className="ri-arrow-right-s-line text-base"></i>
          </Link>
        )}
      </div>
    </div>
  );
}